module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-timber-hamilton-0.c91f5000.jpg";